import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CqCriteriaService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/cq-criterias', query);
  }

  create(body: any) {
    return this.post('/cq-criterias', body);
  }

  find(id) {
    return this.get('/cq-criterias/' + id);
  }

  update(id, body) {
    return this.put('/cq-criterias/' + id, body);
  }

  _delete(id) {
    return this.delete('/cq-criterias/' + id);
  }

  _deletemany(ids) {
    return this.post('/cq-criterias-delemany', ids);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CqCriteria.service.ts